import { mapGetters, mapState, mapMutations } from "vuex";
import { declOfNum } from "../../../_scripts/helpers";
import UserConsent from "../../user-consent/vue-user-consent";

export default {
	template: "#checkout-summary",
	props: {
		submitBlockDisabled: {
			type: Boolean,
			required: true
		},
		submitButtonDisabled: {
			type: Boolean,
			required: true
		},
		userConsentChecked: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			summaryOpened: false
		}
	},
	components: {
		UserConsent
	},
	computed: {
        ...mapGetters({
			products: "summary/products",
			productsCount: "summary/productsCount",
			activeDelivery: "delivery/activeDelivery"
		}),
		...mapState({
			services: state => state.summary.services,
			total: state => state.summary.total,
			isAuthorize: state => state.checkout.isAuthorize,
			sessid: state => state.checkout.sessid
		}),
		productsCountText() {
			return `${this.productsCount} ${declOfNum(this.productsCount, ['товар', 'товара', 'товаров'])}`;
		},
        showDeliveryPriceInfo() {
            return (this.activeDelivery.CODE === "SdekCourier" || this.activeDelivery.CODE === "SdekPickup" || this.activeDelivery.CODE === "SdekPostamat") ? true : false;
        },
        priceWithoutDiscount() {
            return this.total.PRICE_WITHOUT_DISCOUNT_FORMATTED;
		},
		discountPrice() {
			return this.total.FULL_DISCOUNT_PRICE_FORMATTED;
		},
        discountTextPrice() {
			return (!!this.total.DISCOUNT_PRICE) ? `скидка ${this.total.DISCOUNT_PRICE_FORMATTED} ₽` : "";
		},
		discountTextBonuses() {
			return (!!this.total.DISCOUNT_PRICE_BONUS) ? `${this.total.DISCOUNT_PRICE_BONUS} ${declOfNum(this.total.DISCOUNT_PRICE_BONUS, ['бонус', 'бонуса', 'бонусов'])}` : "";
        },
        totalPrice() {
            return this.total.TOTAL_PRICE_FORMATTED;
        },
        orderBonuses() {
			return `+ ${this.total.TOTAL_ACCRUED_BONUS} ${declOfNum(this.total.TOTAL_ACCRUED_BONUS, ['бонус', 'бонуса', 'бонусов'])}`;
		},
		showOrderBonuses() {
			return !!this.total.TOTAL_ACCRUED_BONUS;
		},
		showDiscount() {
			return (!!this.total.DISCOUNT_PRICE || !!this.total.DISCOUNT_PRICE_BONUS);
		},
		infoMessages() {
			return this.total.infoMessages;
		},
		deliveryPrice() {
			return this.total.DELIVERY_PRICE;
		},
		deliveryTime() {
			return this.total.DELIVERY_TIME;
		},
		showDeliveryPrice() {
			return !!this.total.DELIVERY_PRICE;
		}
	},
	methods: {
		toggleSummary() {
			this.summaryOpened = !this.summaryOpened;
		},
		saveOrder() {
			this.$emit("order");
		},
		setUserConsent(e) {
			this.$emit("user-consent", e);
		}
	},
	mounted() {
	},
	created() {
	}
}
